<template>
  <svg width="14"
       height="14"
       viewBox="0 0 14 14"
       :fill="color"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2121_5340)">
      <path
        d="M5.71 4.31C3.79 3 2 4 0.5 5.54L3.82 7.54M9.69 8.29C11 10.21 10 12 8.46 13.5L6.46 10.18"
        stroke="#27C884"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M5.28 5.02L8.98 8.72M3.82 7.53L6.47 10.18C8.59 8.91 11 7.68 12.1 6.54C14.48 4.16 13.1 0.900003 13.1 0.900003C13.1 0.900003 9.84 -0.479997 7.46 1.9C6.32 3 5.08 5.42 3.82 7.53Z"
        stroke="#27C884"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M10.5 4C10.6326 4 10.7598 3.94732 10.8536 3.85355C10.9473 3.75979 11 3.63261 11 3.5C11 3.36739 10.9473 3.24021 10.8536 3.14645C10.7598 3.05268 10.6326 3 10.5 3C10.3674 3 10.2402 3.05268 10.1464 3.14645C10.0527 3.24021 10 3.36739 10 3.5C10 3.63261 10.0527 3.75979 10.1464 3.85355C10.2402 3.94732 10.3674 4 10.5 4ZM3.68 12.44C3.1 13 0.5 13.5 0.5 13.5C0.5 13.5 1 10.9 1.56 10.32C1.76709 10.0986 2.03636 9.94511 2.33238 9.87971C2.62839 9.81431 2.93727 9.84008 3.21835 9.95362C3.49944 10.0672 3.73956 10.2631 3.90711 10.5158C4.07465 10.7684 4.16177 11.0659 4.157 11.369C4.15334 11.5702 4.10923 11.7687 4.02728 11.9525C3.94533 12.1363 3.82723 12.3028 3.68 12.44Z"
        stroke="#27C884"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2121_5340">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#C7FFE7"
    }
  }
}
</script>
